/* Deluxe Footwear — trade / bulk ordering inside the Shopify theme.
   Quote list lives in the visitor's browser (localStorage) until they submit it;
   submission goes through Shopify's contact form, so it lands in the store's inbox. */
(function () {
  'use strict';

  var KEY = 'dfx_quote_v1';
  var cfg = window.DFX_TRADE || { minPairs: 12, quoteUrl: '/cart?view=quote' };

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    render();
  }
  function pairs(item) {
    return Object.keys(item.sizes || {}).reduce(function (n, k) { return n + (parseInt(item.sizes[k], 10) || 0); }, 0);
  }
  function totalPairs(items) { return items.reduce(function (n, it) { return n + pairs(it); }, 0); }
  function money(cents) {
    return 'R ' + (cents / 100).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* merge a product's size quantities into the list */
  function add(entry) {
    var items = read();
    var found = items.filter(function (i) { return i.handle === entry.handle; })[0];
    if (found) {
      Object.keys(entry.sizes).forEach(function (k) {
        found.sizes[k] = (parseInt(found.sizes[k], 10) || 0) + (parseInt(entry.sizes[k], 10) || 0);
      });
    } else {
      items.push(entry);
    }
    write(items);
  }

  /* ---------- header / badge counts ---------- */
  function renderCounts() {
    var items = read(), n = totalPairs(items);
    document.querySelectorAll('[data-dfx-quote-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  /* ---------- PDP size-run builder ---------- */
  function initBuilders() {
    document.querySelectorAll('[data-dfx-size-run]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var inputs = root.querySelectorAll('input[data-size]');
      var totalEl = root.querySelector('[data-dfx-run-total]');
      var hint = root.querySelector('[data-dfx-run-hint]');
      var btn = root.querySelector('[data-dfx-run-add]');
      var status = root.querySelector('[data-dfx-run-status]');
      function update() {
        var t = 0;
        inputs.forEach(function (i) { t += Math.max(0, parseInt(i.value, 10) || 0); });
        totalEl.textContent = t;
        btn.disabled = t === 0;
        if (hint) {
          hint.textContent = t >= cfg.minPairs
            ? 'Wholesale pricing applies to this order (' + cfg.minPairs + '+ pairs).'
            : (t > 0 ? 'Add ' + (cfg.minPairs - t) + ' more pair' + (cfg.minPairs - t === 1 ? '' : 's') + ' for wholesale pricing.' : 'Wholesale pricing from ' + cfg.minPairs + ' pairs, mixed sizes.');
        }
      }
      inputs.forEach(function (i) { i.addEventListener('input', update); });
      root.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = root.querySelector('input[data-size="' + b.dataset.size + '"]');
          inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(b.dataset.step, 10));
          update();
        });
      });
      btn.addEventListener('click', function () {
        var sizes = {};
        inputs.forEach(function (i) { var v = parseInt(i.value, 10) || 0; if (v > 0) sizes[i.dataset.size] = v; });
        add({ handle: root.dataset.handle, title: root.dataset.title, url: root.dataset.url, image: root.dataset.image,
              price: parseInt(root.dataset.price, 10) || 0, sizes: sizes });
        inputs.forEach(function (i) { i.value = ''; });
        update();
        if (status) {
          status.hidden = false;
          status.innerHTML = 'Added to your quote list. <a href="' + cfg.quoteUrl + '">View quote list (' + totalPairs(read()) + ' pairs)</a>';
        }
      });
      update();
    });
  }

  /* ---------- trade grid "add sizes later" buttons ---------- */
  function initQuickQuote() {
    document.querySelectorAll('[data-dfx-quick-quote]').forEach(function (b) {
      if (b.dataset.ready) return;
      b.dataset.ready = '1';
      b.addEventListener('click', function () {
        add({ handle: b.dataset.handle, title: b.dataset.title, url: b.dataset.url, image: b.dataset.image,
              price: parseInt(b.dataset.price, 10) || 0, sizes: { 'Mixed / to confirm': cfg.minPairs } });
        b.textContent = 'Added ✓';
        setTimeout(function () { b.textContent = 'Add to quote'; }, 1800);
      });
    });
  }

  /* ---------- quote list page ---------- */
  function renderList() {
    var root = document.querySelector('[data-dfx-quote-page]');
    if (!root) return;
    var items = read();
    var list = root.querySelector('[data-dfx-quote-items]');
    var empty = root.querySelector('[data-dfx-quote-empty]');
    var form = root.querySelector('[data-dfx-quote-form]');
    var summary = root.querySelector('[data-dfx-quote-summary]');
    var hidden = root.querySelector('[data-dfx-quote-field]');
    empty.hidden = items.length > 0;
    form.hidden = items.length === 0;
    list.innerHTML = items.map(function (it, idx) {
      var rows = Object.keys(it.sizes).map(function (k) {
        return '<li><span>Size ' + esc(k) + '</span><span class="dfx-ql__qty">' +
          '<button type="button" class="dfx-ql__step" data-i="' + idx + '" data-k="' + esc(k) + '" data-d="-1" aria-label="One fewer, size ' + esc(k) + '">−</button>' +
          '<span>' + (parseInt(it.sizes[k], 10) || 0) + '</span>' +
          '<button type="button" class="dfx-ql__step" data-i="' + idx + '" data-k="' + esc(k) + '" data-d="1" aria-label="One more, size ' + esc(k) + '">+</button></span></li>';
      }).join('');
      return '<div class="dfx-ql__item dfx-card">' +
        (it.image ? '<img src="' + esc(it.image) + '" alt="" width="96" height="96" loading="lazy">' : '<span></span>') +
        '<div class="dfx-ql__body"><a class="dfx-ql__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
        '<span class="dfx-ql__meta">' + pairs(it) + ' pairs' + (it.price ? ' · retail ' + money(it.price) + ' each' : ' · price on request') + '</span>' +
        '<ul class="dfx-ql__sizes">' + rows + '</ul></div>' +
        '<button type="button" class="dfx-ql__remove" data-remove="' + idx + '" aria-label="Remove ' + esc(it.title) + '">Remove</button></div>';
    }).join('');
    var n = totalPairs(items);
    summary.innerHTML = '<strong>' + n + ' pairs</strong> across ' + items.length + ' product' + (items.length === 1 ? '' : 's') +
      (n >= cfg.minPairs ? ' · qualifies for wholesale pricing' : ' · wholesale pricing from ' + cfg.minPairs + ' pairs');
    hidden.value = items.map(function (it) {
      return it.title + ' — ' + Object.keys(it.sizes).map(function (k) { return 'size ' + k + ': ' + it.sizes[k]; }).join(', ') +
        ' (' + pairs(it) + ' pairs)' + (it.url ? ' ' + location.origin + it.url : '');
    }).join('\n') + '\nTOTAL: ' + n + ' pairs';
    list.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { var a = read(); a.splice(+b.dataset.remove, 1); write(a); });
    });
    list.querySelectorAll('.dfx-ql__step').forEach(function (b) {
      b.addEventListener('click', function () {
        var a = read(), it = a[+b.dataset.i], k = b.dataset.k;
        it.sizes[k] = Math.max(0, (parseInt(it.sizes[k], 10) || 0) + parseInt(b.dataset.d, 10));
        if (it.sizes[k] === 0) delete it.sizes[k];
        if (Object.keys(it.sizes).length === 0) a.splice(+b.dataset.i, 1);
        write(a);
      });
    });
  }

  function initQuotePage() {
    var root = document.querySelector('[data-dfx-quote-page]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var imp = root.querySelector('[data-dfx-import-cart]');
    if (imp) {
      imp.addEventListener('click', function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          if (!cart.items.length) { imp.textContent = 'Your cart is empty'; return; }
          cart.items.forEach(function (li) {
            var size = (li.variant_options && li.variant_options[li.variant_options.length - 1]) || li.variant_title || 'One size';
            var s = {}; s[size] = li.quantity;
            add({ handle: li.handle, title: li.product_title, url: li.url.split('?')[0], image: li.image,
                  price: li.price, sizes: s });
          });
          imp.textContent = 'Cart items added ✓';
        }).catch(function () { imp.textContent = 'Could not read the cart'; });
      });
    }
    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () { renderList(); });
    }
    if (root.querySelector('[data-dfx-quote-sent]')) { write([]); }
  }

  /* ---------- cart drawer nudge at 12+ pairs ---------- */
  var nudging = false;
  function cartNudge() {
    var drawer = document.querySelector('.cart-drawer__content');
    if (!drawer || nudging) return;
    nudging = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var el = drawer.querySelector('.dfx-cart-nudge');
      if (cart.item_count >= cfg.minPairs) {
        if (!el) {
          el = document.createElement('div');
          el.className = 'dfx-cart-nudge';
          el.innerHTML = '<strong>' + cart.item_count + ' pairs — you qualify for wholesale pricing.</strong>' +
            '<span>Send this as a trade quote instead of paying retail.</span>' +
            '<a class="dfx-btn dfx-btn--ink" href="' + cfg.quoteUrl + '#enquiry">Get a trade quote</a>';
          drawer.insertBefore(el, drawer.firstChild);
        }
      } else if (el) { el.remove(); }
    }).catch(function () {}).then(function () { nudging = false; });
  }

  function render() { renderCounts(); renderList(); }

  function init() {
    render();
    initBuilders();
    initQuickQuote();
    initQuotePage();
    cartNudge();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        initBuilders(); initQuickQuote();
        var d = document.querySelector('.cart-drawer__content');
        if (d && d.offsetParent !== null) cartNudge();
      }, 400);
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
